{
  "pageTitle": "Endre partner",
  "backLink": "Tilbake til endre andelseierskap",
  "cardTitle": "Partner",
  "cardDescription": "Legg til eller endre partner. Partner må være registrert i Viken Skog",
  "cta": "Legg til partner",
  "removeBreadcrumb": "Fjern partner",
  "removeChoice": {
    "heading": "Andelseier",
    "question": "Skal {{partnerName}} fortsette som andelseier etter å ha blitt fjernet som partner?",
    "yes": "Ja, fortsett som andelseier",
    "yesDescription": "Partneren beholder eiendommene med andelskapitalen",
    "no": "Nei, ikke fortsett som andelseier",
    "noDescription": "partneren beholder eiendommene, men andelskapitalen utbetales til skogeier"
  },
  "removeNoMembership": {
    "title": "Oppsummering",
    "description": "Sjekk at informasjonen stemmer før du fjerner partneren",
    "propertyHeading": "Eiendom",
    "partnerPropertiesDescription": "Oversikten viser eiendommene tilhørende partner",
    "ownerPropertiesDescription": "Oversikten viser eiendommene dine, med ny beregnet andelskapital",
    "mainNumber": "Hovednummer",
    "ownership": "Eierskap",
    "calculatedShareCapital": "Beregnet andelskapital (NOK)",
    "totalCalculatedShareCapital": "Totalt beregnet andelskapital",
    "sharedWithPartner": "Deles med partner",
    "noProperties": "Ingen eiendommer",
    "capitalHeading": "Endring i andelseierskap",
    "mandatory": {
      "title": "Pliktig andelskapital",
      "description": "Oppdatert pliktig andelskapital"
    },
    "remaining": {
      "title": "Gjenstående kapital",
      "description": "Gjenstående andelskapital og tilleggskapital etter overdragelse av partner sine eiendommer"
    },
    "owed": {
      "title": "Skyldig andelskapital",
      "description": "Trekkes automatisk ved fremtidige tømmeroppgjør"
    },
    "payout": {
      "title": "Andelskapital til utbetaling",
      "description": "Innbetalt andelskapital som overstiger pliktig andelskapital utbetales til skogeier"
    },
    "unchanged": {
      "title": "Ingen endring i pliktig andelskapital",
      "description": "Skogeier har allerede betalt inn all pliktig andelskapital som kreves. Endringen medfører ingen nye innbetalinger."
    },
    "submit": "Fjern partner"
  }
}
